<template>
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay user-config-shell">
        <div class="row dashboard-header g-3 align-items-center">
          <div class="col-12 col-lg-8">
            <h2 class="dashboard-title mb-1">Gestión de usuarios</h2>
            <p class="dashboard-subtitle mb-0">
              Administra usuarios del sistema, su estado de acceso y sesiones activas.
            </p>
          </div>
          <div class="col-12 col-lg-4 d-flex justify-content-lg-end">
            <router-link class="btn btn-primary dashboard-main-btn" to="/axccAdminSettings/0" style="color: white;">
              Nuevo Usuario
            </router-link>
          </div>
        </div>

        <div class="table-card">
          <div v-if="this.ready" class="table-responsive horizontal-scrollable">
            <table class="table table-compact table-striped align-middle user-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Correo</th>
                  <th>Activo</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="u in this.users" v-bind:key="u.id">
                  <td>
                    <router-link :to="`/axccAdminSettings/${u.id}`">{{ u.last_name }}, {{ u.first_name }}</router-link>
                  </td>
                  <td>{{ u.email }}</td>

                  <td v-if="u.active === 1">
                    <span class="badge bg-success user-badge">Active</span>
                  </td>
                  <td v-else>
                    <span class="badge bg-danger user-badge">Inactive</span>
                  </td>

                  <td v-if="u.token.id > 0">
                    <a href="javascript:void(0);">
                      <span class="badge bg-success user-badge" @click="logUserOut(u.id)">Logged in</span>
                    </a>
                  </td>
                  <td v-else>
                    <span class="badge bg-danger user-badge">Not logged in</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="loading-shell">Loading...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Security from "../security";
import notie from 'notie'
import { store } from "../store";


export default {
    data(){
        return {
            users: [],
            ready: true
        }
    },
    beforeMount(){
        Security.requireToken();

        fetch(process.env.VUE_APP_API_URL + "/admin/users", Security.requestOptions(""))
        .then((response) => response.json())
        .then((response) => {
            if (response.error) {
                // console.log(response.message, response.error);
                notie.alert({
                    type: "error",
                    text: response.message,
                })
            } else {
                this.users = response.data.users;
                this.ready = true;    
            }
        })
        .catch((error)=>{
            // console.log(error);
            notie.alert({
                type: "error",
                text: error,
                store,
            })
        });
    },
    methods: {
        logUserOut(id){
            if(id !== store.user.id){
                notie.confirm({
                    text: "Are you sure you want to log this user out?",
                    submitText: "Log Out",
                    submitCallback: () => {
                        console.log("Would log out user id", id);
                        fetch(process.env.VUE_APP_API_URL +"/admin/log-user-out/" + id, Security.requestOptions(""))
                        .then((response) => response.json())
                        .then((data) => {
                            if(data.error){
                                this.$emit('error', data.message);
                            } else {
                                this.$emit('success', data.message);
                                this.$emit('forceUpdate');
                            }
                        })
                    }
                })
            } else {
                this.$emit('error', "You can't log yourself out!");
            }
        }
    }
}
</script>

<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin: 0;
}

.dashboard-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.dashboard-main-btn {
  border-radius: 999px;
  font-weight: 600;
}

.table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
  padding: 12px;
}

.horizontal-scrollable {
  overflow-x: auto;
  white-space: nowrap;
}

.user-table thead th {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%);
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
}

.user-badge {
  border-radius: 999px;
  padding: 0.4rem 0.7rem;
}

.loading-shell {
  color: #4b5563;
  font-weight: 600;
  padding: 12px;
}

@media (max-width: 767px) {
  .cardplay {
    padding: 15px;
  }
}
</style>
